export default __webpack_public_path__ + "static/media/summerchallenge04.2c43f73e.jpg";